export const TABLE_ROW_COMMITED = "data.TableRowCommitted";
export const CONTEXT_UPDATED = "system.COntextUpdated";